import React, { useEffect, useState, useContext } from 'react';
import { message, Form } from 'antd';
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { DOCUMENT_CATEGORY, LISTENER_CATEGORIES } from '../../../shared/types/firestoreType';
import { PAGINATION } from '../../../shared/types/paginationType';
import { ModalContext } from '../../../shared/context/ModalContext';

import global from '../../../shared/utility/global';

import Header from './Header';
import Filter from './Filter';
import Items from './Items';
import FormModal from './FormModal';

export default function Index(_) {
    const modal = useContext(ModalContext);
    const categoryFirestore = new CommonCloudFirestore(DOCUMENT_CATEGORY);

    const [filterForm] = Form.useForm();
    const [pagination, setPagination] = useState({ ...PAGINATION, size: 30 });
    const [items, setItems] = useState([]);
    const [dragId, setDragId] = useState();

    const [openForm, setOpenForm] = useState(false);
    const [id, setId] = useState('');

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setPagination({ ...pagination, loading: true });
        const items = await categoryFirestore.getDocuments();
        const orderItems = items.sort(global.orderBy('index'));
        setItems(orderItems);
        onPagination({ ...pagination }, orderItems);
    };

    const onPagination = (_pagination, _items) => {
        const formValues = filterForm.getFieldValue();
        const filtered = (_items ?? items).filter(item => {
            return global.formatSearch(item.name).match(global.formatSearch(formValues.keyword));
        });
        setPagination(global.localPagination(_pagination, filtered));
    };

    const onDelete = async (item) => {
        modal.confirm(`La categoría se eliminara permanentemente. ¿Desea continuar?`, async () => {
            var result = await categoryFirestore.deleteDocument(item.id, [LISTENER_CATEGORIES]);

            if (result)
                message.success('Proceso realizado con éxito.');
            else
                message.error('Ocurrió un error inesperado.');

            onLoad();
        });
    };

    const onEdit = (item) => {
        setOpenForm(true);
        setId(item.id);
    }

    /**************************************************/

    const onDragStart = (ev) => {
        setDragId(ev.currentTarget.id);
        var querySelectorAll = document.querySelectorAll('.content-card-category > .catalog-card-content');
        querySelectorAll.forEach(function (item) {
            item.classList.add('catalog-card-pointer-events');
        });
    };

    const onDragEnter = (ev) => {
        ev.currentTarget.classList.add('over');
    };

    const onDragLeave = (ev) => {
        ev.currentTarget.classList.remove('over')
    };

    const onDrop = async (ev) => {
        if (ev.currentTarget.id === dragId)
            return;

        const fetchIndex = (id) => {
            var result = 0;
            for (let index = 0; index < items.length; index++) {
                if (items[index].id === id) {
                    result = index;
                    break;
                }
            }
            return result;
        };

        setPagination({ ...pagination, loading: true });

        var orderItems = [];
        const dragIndex = fetchIndex(dragId);
        const dropIndex = fetchIndex(ev.currentTarget.id);

        const reorganizedItems = items.map(m => ({ ...m })).map((item, index) => {
            if (item.id === dragId) {
                item.index = dropIndex;
                orderItems.push({ id: item.id, index: dropIndex });
            }
            else if (item.id === ev.currentTarget.id) {
                item.index = dragIndex;
                orderItems.push({ id: item.id, index: dragIndex });
            }
            else {
                item.index = index;
            }
            return item;
        }).sort(global.orderBy('index'));

        /******************* SAVE  ***************/
        var response = await categoryFirestore.updatePositions(orderItems, [LISTENER_CATEGORIES]);
        if (response) {
            setItems(reorganizedItems);
            onPagination(pagination, reorganizedItems);
            message.success("Orden cambiado correctamente.");
        }
        else {
            message.error("Ocurrió un error al cambiar el orden, vuelvalo a intentar mas tarde.");
        }
    };

    const onDragEnd = () => {
        var querySelectorAll1 = document.querySelectorAll('.content-card-category > .catalog-card-content');
        querySelectorAll1.forEach(item => {
            item.classList.remove('catalog-card-pointer-events');
        });

        var querySelectorAll2 = document.querySelectorAll('.content-card-category');
        querySelectorAll2.forEach(item => {
            item.classList.remove('over');
        });
    };

    return (
        <>
            <Header
                onLoad={onLoad}
                onNew={() => {
                    setId('');
                    setOpenForm(true);
                }}
            />
            <Filter
                form={filterForm}
                onLoad={onLoad}
            />
            <Items
                pagination={pagination}
                onDelete={onDelete}
                onEdit={onEdit}
                onDragStart={onDragStart}
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
                onDragEnd={onDragEnd}
            />
            <FormModal
                id={id}
                open={openForm}
                onLoad={onLoad}
                onCancel={() => {
                    setId('');
                    setOpenForm(false);
                }}
            />
        </>
    )
}